import { render, staticRenderFns } from "./table-item.vue?vue&type=template&id=44d0c8b2&scoped=true"
import script from "./table-item.vue?vue&type=script&lang=js"
export * from "./table-item.vue?vue&type=script&lang=js"
import style0 from "./table-item.vue?vue&type=style&index=0&id=44d0c8b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d0c8b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d0c8b2')) {
      api.createRecord('44d0c8b2', component.options)
    } else {
      api.reload('44d0c8b2', component.options)
    }
    module.hot.accept("./table-item.vue?vue&type=template&id=44d0c8b2&scoped=true", function () {
      api.rerender('44d0c8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-render/container-item/table-item.vue"
export default component.exports